import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    input,
    output,
    TemplateRef,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { MegaMenuItem, MenuItem } from 'primeng/api';
import { MegaMenu, MegaMenuModule } from 'primeng/megamenu';
import { Ripple } from 'primeng/ripple';

export { MegaMenuItem, MenuItem } from 'primeng/api';

@Component({
    selector: 'fcp-megamenu',
    imports: [CommonModule, MegaMenuModule, RouterModule, Ripple],
    templateUrl: './fcp-megamenu.component.html',
    styleUrl: './fcp-megamenu.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    }
})
export class FcpMegamenuComponent {
    private readonly megamenu = viewChild(MegaMenu);

    @ContentChild('start', { read: TemplateRef }) startTemplate?: TemplateRef<unknown>;
    @ContentChild('end', { read: TemplateRef }) endTemplate?: TemplateRef<unknown>;

    menuItemClick = output<FcpMegamenuItemClickEvent>();
    e2e = input<string | null>(null);
    model = input<MegaMenuItem[]>();
    style = input<Record<string, string | number>>();
    orientation = input<MegaMenuOrientation>(MegaMenuOrientation.Horizontal);
    id = input<string>();
    ariaLabel = input<string>();
    ariaLabelledBy = input<string>();
    breakpoint = input<string>('960px');
    scrollHeight = input<string>('20rem');
    disabled = input<boolean>(false);
    tabindex = input<number>(0);

    hasSubmenu(item: MenuItem): boolean {
        return Array.isArray(item.items) && item.items.length > 0;
    }

    externalLinkRel(target: string | undefined): string | null {
        return target === '_blank' ? 'noopener noreferrer' : null;
    }

    onItemLinkClick(event: MouseEvent, item: MenuItem): void {
        if (!item.routerLink?.length) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        item.command?.({ originalEvent: event, item });
        this.megamenu()?.hide(event);
        this.menuItemClick.emit({ item: { routerLink: [...item.routerLink] } });
    }
}

export interface FcpMegamenuItemClickEvent {
    item?: { routerLink?: string[] };
}

/** Shared class for selected menubar roots — used by consumers (e.g. admin nav) and Storybook. */
export const FCP_MEGAMENU_MENUBAR_ITEM_SELECTED_CLASS = 'fcp-megamenu-menubar-item--selected';

export enum MegaMenuOrientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical'
}
